module.exports = __webpack_public_path__ + "img/Degrees-Distributions-150x150.eeba7176.png";